const POPUP_BOTTOM_POSITION_THRESHOLD = 90

export const usePopupPosition = (
  targetBoundaries: DOMRect,
  relativeTo: HTMLElement,
  popup: HTMLElement | null,
  position?: string,
  verticalSpace?: number
): { leftPos: number; topPos: number } | undefined => {
  if (!popup) {
    return
  }

  const TARGET_MARGIN = verticalSpace || 0

  const popupBoundaries: DOMRect = popup.getBoundingClientRect()
  const popupHeightWithMargin = popupBoundaries.height + TARGET_MARGIN

  if (!(relativeTo && targetBoundaries)) {
    return
  }

  const relativeBoundaries: DOMRect = relativeTo.getBoundingClientRect()
  const absoluteTop: number = targetBoundaries.top - popupHeightWithMargin
  let relativeTop = 8
  relativeTop +=
    absoluteTop < POPUP_BOTTOM_POSITION_THRESHOLD
      ? targetBoundaries.bottom - relativeBoundaries.top + TARGET_MARGIN
      : targetBoundaries.top - relativeBoundaries.top - popupHeightWithMargin

  const alignCenter = () => {
    const targetXCenter: number =
      (targetBoundaries.right + targetBoundaries.left) / 2
    const absoluteLeft: number = targetXCenter - popupBoundaries.width / 2
    const relativeLeft: number = absoluteLeft - relativeBoundaries.left

    return {
      leftPos: relativeLeft,
      topPos: relativeTop
    }
  }

  const alignLeft = () => {
    return {
      leftPos:
        targetBoundaries.left -
        relativeBoundaries.left +
        targetBoundaries.width / 2,
      topPos: relativeTop
    }
  }

  switch (position) {
    case 'center': {
      return alignCenter()
    }
    case 'left': {
      return alignLeft()
    }
    default: {
      return alignCenter()
    }
  }
}
